module.exports = __webpack_public_path__ + "static/media/step2.17ad4efe.png";